export default __webpack_public_path__ + "static/media/icons8-photo-gallery-48.353cc231.svg";